import firebase from "firebase";

const config = {
  apiKey: "AIzaSyAbFAPco678kJYSCqQ4iJf1fzqI8Nc55oE",
  authDomain: "uranch-19d69.firebaseapp.com",
  projectId: "uranch-19d69",
  storageBucket: "uranch-19d69.appspot.com",
  messagingSenderId: "242208945546",
  appId: "1:242208945546:web:75ed945aa3a5e242ab0473",
  measurementId: "G-XKZE4JWVB2",
};
firebase.initializeApp(config);
export default firebase;
